import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../redux/epics/utils';

const GET_SURVEY_DETAILS_ACTION_TYPES = createAPILifecycleActionTypes(
  'GET_SURVEY_DETAILS_ACTION_TYPES',
);
export const getSurveyDetailsAction = createAPILifecycleActions(
  GET_SURVEY_DETAILS_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SURVEY_DETAILS_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case GET_SURVEY_DETAILS_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    case GET_SURVEY_DETAILS_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };
    case GET_SURVEY_DETAILS_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const getSurveyDetailsEpic = createAmplifyAPICallEpic({
  actionType: GET_SURVEY_DETAILS_ACTION_TYPES.BEGIN,
  api: '/getSurveyDetails',
  successCallback: response => [getSurveyDetailsAction.SUCCESS(response)],
  errorCallback: error => [getSurveyDetailsAction.FAILURE(error)],
});
